import * as React from 'react'

export type StateProps = {
  firstName: string
  lastName: string
  phoneNumber: string
  email: string
  shippingFirstname: string
  shippingLastname: string
  shippingAddress1: string
  shippingAddress2: string
  shippingZip: string
  shippingCity: string
}

type ProviderValue = {
  user: StateProps
  setUser: (user: Partial<StateProps>) => void
}

const reducer = (user: StateProps, newUser: Partial<StateProps>) => {
  return { ...user, ...newUser }
}

const localState = JSON.parse(
  (typeof window !== `undefined` && window.localStorage.getItem('user')) || '{}'
)

const UserContext = React.createContext({} as ProviderValue)

const UserProvider = ({ children }) => {
  const [user, setUser] = React.useReducer(reducer, localState || {})

  React.useEffect(() => {
    localStorage.setItem('user', JSON.stringify(user))
  }, [user])

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
      }}
    >
      {children}
    </UserContext.Provider>
  )
}

export default UserContext
export { UserProvider }
